export const REQUEST_SUPPORT_MODAL_SHOW = '[REQUEST_SUPPORT] MODAL_SHOW';
export const REQUEST_SUPPORT_MODAL_HIDE = '[REQUEST_SUPPORT] MODAL_HIDE';
export const REQUEST_SUPPORT_REQUEST = '[REQUEST_SUPPORT] REQUEST';
export const REQUEST_SUPPORT_DONE = '[REQUEST_SUPPORT] DONE';


export const requestSupportModalShow = () => ({type: REQUEST_SUPPORT_MODAL_SHOW});
export const requestSupportModalHide = () => ({type: REQUEST_SUPPORT_MODAL_HIDE});
export const requestSupportRequest = data => ({type: REQUEST_SUPPORT_REQUEST, data});
export const requestSupportDone = () => ({type: REQUEST_SUPPORT_DONE});